import {userConstants} from '../constants/user.constants.js';

const initialState = {
    emailFailed : false
}

export const user = (state = initialState, action) => {
    switch(action.type) {
        
        case userConstants.LOY3_REGISTER_SUCCESS:
            return {
                ...state,
                loy3RegisterData: action.loy3RegisterData
            }
        case userConstants.LOY3_REGISTER_FAILED:
            return {
                ...state,
                emailFailed: action.emailFailed
            }
        case userConstants.LOY3_NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                loy3NewPassword: action.loy3NewPassword
            }
        case userConstants.UPLOAD_FILE_SUCCESS:
            return {
                ...state,
                uploadFile : action.payload
            }
        default:
            return state
    }
}
